import { useState } from "react";
import { getAuthHeaders, clearToken } from "./authService";

export function useNameGeneration() {
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateNames = async (singleName, gender, locale, theme, vibe = null) => {
    setLoading(true);
    setNames([]);
    setError(null);

    const fetchOnce = async (retry = false) => {
      const authHeaders = await getAuthHeaders();
      const response = await fetch("/api/Recommend", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders,
        },
        body: JSON.stringify({
          SingleName: singleName || null,
          Gender: gender,
          Locale: locale,
          Theme: theme === "general" ? null : theme,
          Vibe: vibe || null,
        }),
      });

      if (response.status === 401 && !retry) {
        clearToken();
        return fetchOnce(true);
      }
      return response;
    };

    try {
      const response = await fetchOnce();
      if (response.status === 429) {
        const data = await response.json().catch(() => ({}));
        setError(data.loginToImprove ? "rateLimitErrorAnon" : "rateLimitError");
        setLoading(false);
        return;
      }
      const data = await response.json();
      if (Array.isArray(data)) {
        setNames(data);
      } else if (data && data.length && data[0].name) {
        setNames(data);
      } else if (
        data &&
        data.choices &&
        data.choices[0] &&
        data.choices[0].message &&
        data.choices[0].message.content
      ) {
        try {
          const parsed = JSON.parse(data.choices[0].message.content);
          setNames(parsed);
        } catch {
          setNames([]);
        }
      } else {
        setNames([]);
      }
    } catch {
      setNames([]);
    }
    setLoading(false);
  };

  const clearError = () => setError(null);

  return { names, loading, error, generateNames, clearError };
}
